import React, { useEffect, useRef, useState } from 'react'
import Webcam from 'react-webcam';
import { saveOrUpdateTestAssesmentSnaps } from '../Service/AssesmentResultService';
import { getUser } from '../Service/LoginService';
import  styles from './Screenshot.module.css';
import { Store } from '../App';
import { useContext } from 'react';
import { loadPopup } from '../Utils/LoginUtils';

function Screenshot({ assesmentId }) {
    const [dateObj, setDateObj] = useState('');
    const webcamRef = useRef(null);
    const { data } = useContext(Store);
    const token = getUser();
    const screenShotTimer = data !== null &&data.screenShotTimer!=null ? data.screenShotTimer : 50;
    console.log("screen "+screenShotTimer);
    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
                let data = new FormData()
                data.append('encodedImageString', imageSrc);
                data.append('testId', assesmentId);

                saveOrUpdateTestAssesmentSnaps(data).then(response => {
                    // console.log('Snap uploaded.', response);
                }).catch(err => {
                    console.log('error catched while saveOrUpdateTestAssesmentSnaps', err);
                });
            }else{
                loadPopup('Please turn on your camera!!!');
            }
        });

    useEffect(() => {
        let secTimer = setInterval(() => {
            setDateObj(new Date().toLocaleString([], {
                hour12: false
            }));
            if (token) {
                capture();
            }
        }, screenShotTimer*1000)
        return () => clearInterval(secTimer);
    }, [dateObj]);

    return (
        <div className={styles.test}>
            {
                token && <Webcam
                    ref={webcamRef}
                    imageSmoothing={true}
                    screenshotFormat="image/jpeg"
                    audio={false} mirrored={true}
                    className={styles.webcam}
                />
            }
        </div>
    )

}

export default Screenshot